import { Grid2, IconButton, Typography, useMediaQuery } from "@mui/material";
import { Field, useFormikContext } from "formik";
import React, { useEffect } from "react";
import DeleteIco from "../../../assets/icons/DeleteIco";
import CommonTextField from "../../../component/Input";
import { HandleSkeletion } from "../../../utils/constants";
import { CommonGrid2 } from "../../common-components/StyledComponents";

function References({ data, loading, handleDeleteReferenceClick, disabled }) {
  const { values, errors, setFieldValue, handleBlur } = useFormikContext();
  const lg = useMediaQuery("(min-width:767px)");
  const [localValue, setLocalValue] = React.useState(values.references);

  useEffect(() => {
    setLocalValue(values.references);
  }, [values]);

  const debounceTimer = React.useRef(null);

  const handleInputChange = (index, field, e) => {
    const value = e.target.value;
    const updated = [...localValue];
    updated[index][field] = value;
    setLocalValue(updated);

    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      setFieldValue(`references.${index}.${field}`, value);
    }, 400);
  };

  return (
    <CommonGrid2
      container
      spacing={2}
      gap={loading ? "0px" : "1rem"}
      display={"flex"}
      justifyContent={"space-between"}
    >
      {data.map((item, index) => {
        return loading ? (
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <HandleSkeletion height={100} />
          </Grid2>
        ) : (
          <Grid2
            container
            spacing={2}
            key={index}
            size={12}
            border={"1px solid #EAECF0"}
            borderRadius={"8px"}
            padding={"10px 1rem 1rem"}
            position={"relative"}
          >
            <Grid2
              size={{ xs: 12, sm: 6, md: 4 }}
              display={"flex"}
              flexDirection={"column"}
              gap={"5px"}
            >
              <Typography variant={lg ? "h6" : "subtitle3"}>
                {"Name"}
              </Typography>
              <Field name={item.name}>
                {({ field, form }) => {
                  return (
                    <CommonTextField
                      value={item.name}
                      onChange={(e) => handleInputChange(index, "name", e)}
                      placeholder="Enter the name"
                      placeholderFontSize={lg ? "15px" : "13px"}
                      fontSize={lg ? "15px" : "13px"}
                      padding={"12px"}
                      error={Boolean(form.errors.references?.[index]?.name)}
                      disabled={disabled}
                      helperText={form.errors.references?.[index]?.name}
                    />
                  );
                }}
              </Field>
            </Grid2>

            <Grid2
              size={{ xs: 12, sm: 6, md: 4 }}
              display={"flex"}
              flexDirection={"column"}
              gap={"5px"}
            >
              <Typography variant={lg ? "h6" : "subtitle3"}>
                {"Phone"}
              </Typography>
              <Field name={item.phone}>
                {({ field, form }) => {
                  return (
                    <CommonTextField
                      value={item.phone}
                      onChange={(e) => handleInputChange(index, "phone", e)}
                      placeholder="Enter the phone"
                      placeholderFontSize={lg ? "15px" : "13px"}
                      fontSize={lg ? "15px" : "13px"}
                      padding={"12px"}
                      error={Boolean(form.errors.references?.[index]?.phone)}
                      disabled={disabled}
                      helperText={form.errors.references?.[index]?.phone}
                    />
                  );
                }}
              </Field>
            </Grid2>

            <Grid2
              size={{ xs: 12, sm: 6, md: 4 }}
              display={"flex"}
              flexDirection={"column"}
              gap={"5px"}
            >
              <Typography variant={lg ? "h6" : "subtitle3"}>
                {"Email"}
              </Typography>
              <Field name={item.email}>
                {({ field, form }) => {
                  return (
                    <CommonTextField
                      value={item.email}
                      placeholderFontSize={lg ? "15px" : "13px"}
                      fontSize={lg ? "15px" : "13px"}
                      padding={"12px"}
                      onChange={(e) => handleInputChange(index, "email", e)}
                      placeholder="Enter the email"
                      error={Boolean(form.errors.references?.[index]?.email)}
                      disabled={disabled}
                      helperText={form.errors.references?.[index]?.email}
                    />
                  );
                }}
              </Field>
            </Grid2>
            {data.length !== 1 && (
              <IconButton
                onClick={() => handleDeleteReferenceClick(item, index)}
                size="small"
                disabled={disabled}
                sx={{
                  position: "absolute",
                  top: "6px",
                  right: "12px",
                  color: "#D92D20",
                }}
              >
                <DeleteIco
                  strokeWidth={2}
                  stroke={disabled ? "#98A2B3" : "#D92D20"}
                />
              </IconButton>
            )}
          </Grid2>
        );
      })}
    </CommonGrid2>
  );
}

export default References;
